import { useEffect } from "react";

export const SITE = "https://www.apptarget.ai";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export function useSeo(title, description, path = "/") {
  useEffect(() => {
    const full = `${title} | AppTarget`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${SITE}${path}`);
    const canon = document.head.querySelector('link[rel="canonical"]');
    if (canon) canon.setAttribute("href", `${SITE}${path}`);
  }, [title, description, path]);
}
